/**
 * govedo-ui specific English translations.
 *
 * The app is pinned to Slovenian (`lng: "sl"` in i18n.js); this file exists
 * because i18n.js registers an `en` resource bundle for every app.
 */
export default {};
